<ng-content></ng-content>
<div
  class="wchfs-ripple"
  [wchfsRippleCentered]="wchfsRippleCentered"
  [wchfsRippleColor]="rippleColor"
  [wchfsRippleDisabled]="this.underlineOnHover ? true : this.disabled"
  [wchfsRippleTrigger]="hostElement"
  wchfsRipple
></div>
